import { render, staticRenderFns } from "./InventarioItemBemConsumoList.vue?vue&type=template&id=741efb3c"
import script from "./InventarioItemBemConsumoList.vue?vue&type=script&lang=js"
export * from "./InventarioItemBemConsumoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports